import { getEnv } from "../../../utils/env"
import { postRequest } from "../../mp-utils/generic-utils"

export const manualAddStudent = async (id: string): Promise<string> => {
  const url = `${getEnv("CLOUD_FUNCTION_ROOT")}/authGroup-manualAddStudent?`
  const raw = await postRequest(url, { id })
  // postRequest uses responseType:"text" so raw is a string, but handle
  // both cases defensively in case axios transforms the JSON body.
  const parsed: { password: string } =
    typeof raw === "string" ? JSON.parse(raw) : raw
  if (!parsed?.password) {
    throw new Error("Failed to create student credentials: unexpected server response")
  }
  return parsed.password
}
